module.exports = __webpack_public_path__ + "img/9788958288589.dca74e56.jpg";